import React from 'react';

interface RadioButtonProps {
    value: string;
    name: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    required?: boolean;
    label?: string;
    className?: string;
}

export default function RadioButton({
    value,
    name,
    checked,
    onChange,
    disabled = false,
    required = false,
    label,
    className = '',
}: RadioButtonProps) {
    const id = Math.random().toString(36).substring(7);
    return (
        <div
            className={`${className} flex items-center cursor-pointer ${
                disabled ? 'opacity-50 cursor-not-allowed' : ''
            }`}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <div className="relative h-6 w-6">
                <input
                    disabled={disabled}
                    className="appearance-none h-6 w-6 border border-gray-300 border-2 rounded-full bg-input-backgroundColor cursor-pointer hover:border-primary checked:border-primary checked:bg-input-backgroundColor focus:outline-none"
                    type="radio"
                    value={value}
                    name={name}
                    checked={checked}
                    required={required}
                    onChange={onChange}
                    id={id}
                />
                <div
                    className={`absolute top-0 left-0 right-0 bottom-0 m-auto rounded-full transition-all duration-100 ${
                        checked ? 'bg-primary h-3 w-3' : 'bg-transparent z-[-1] h-0 w-0'
                    }`}
                ></div>
            </div>
            {label && (
                <label className="ml-2 relative cursor-pointer" htmlFor={id}>
                    {label}
                </label>
            )}
        </div>
    );
}
